const ProductsCancelledDetailsStyle = () => `
<style>
    .card-container {
    background-color: #FFF;
    display: flex;
    padding: 20px;
    border-radius: 11px;
    width: 320px;
    margin-bottom: 16px;
    align-items: center;
    }
    .product-image {
        width: 128px;
        height: 128px;
    }
    .title-container p {
        margin: 5px 0;
    }
    .color {
        color: #000;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        border: 1px solid #000;
    }
</style>`;

export default ProductsCancelledDetailsStyle;
